/**
 * Install-app affordance — appears only when the browser says the console is
 * installable (the `beforeinstallprompt` event), and disappears once installed.
 * Clicking shows the native install prompt. Purely progressive: no button, no harm.
 */
import { useEffect, useState } from 'react'
import { Button } from '@solum/ui'

interface BIPEvent extends Event { prompt: () => Promise<void>; userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }> }

export function InstallButton() {
  const [evt, setEvt] = useState<BIPEvent | null>(null)
  useEffect(() => {
    const onPrompt = (e: Event) => { e.preventDefault(); setEvt(e as BIPEvent) }
    const onInstalled = () => setEvt(null)
    window.addEventListener('beforeinstallprompt', onPrompt)
    window.addEventListener('appinstalled', onInstalled)
    return () => { window.removeEventListener('beforeinstallprompt', onPrompt); window.removeEventListener('appinstalled', onInstalled) }
  }, [])

  if (!evt) return null
  return (
    <Button size="sm" variant="ghost" data-testid="install-app" title="Install Moonbase as an app"
      onClick={async () => { await evt.prompt(); const r = await evt.userChoice; if (r.outcome === 'accepted') setEvt(null) }}>
      ⬇ Install
    </Button>
  )
}
